import { FormattedDate } from 'react-intl';

import { useTargetAccumulatorSelector } from '@/App/tiles/TargetAccumulator/TargetAccumulatorContext.tsx';
import { TargetAccumulatorFormField } from '@/App/tiles/TargetAccumulator/TargetAccumulatorFormField.tsx';

export const HedgePaymentDate = () => {
  const hedgePaymentDate = useTargetAccumulatorSelector(
    (targetAccumulator) => targetAccumulator?.properties.hedgePaymentDate,
  );

  return (
    hedgePaymentDate && (
      <TargetAccumulatorFormField formattedMessageId="targetAccumulator.form.hedgePaymentDate">
        <span className="fs-12 ps-2">
          <FormattedDate value={hedgePaymentDate} day="2-digit" month="short" year="numeric" timeZone="UTC" />
        </span>
      </TargetAccumulatorFormField>
    )
  );
};
